import React from 'react';
import Lottie from '../../generic-components/Lottie';
import LogoLoaderLottie from '../../assets/lotties/lili_logo_loading_animation.json';

interface LiliLottieLoaderProps {
  onComplete?: () => void;
}

export const LiliLottieLoader = ({ onComplete }: LiliLottieLoaderProps) => {
  const eventListeners = [
    {
      event: 'complete',
      callback: onComplete || (() => {}),
    },
  ];
  return (
    <div className='absolute z-[9999] w-full h-full bg-surface-primary-bw-00 flex items-center justify-center'>
      <Lottie
        className='w-[128px] h-[78px]'
        isAutoplay
        isLoop
        lottieAsset={LogoLoaderLottie}
        eventListeners={eventListeners}
      />
    </div>
  );
};
//
